<template>
  <header class="header">
    <div class="logo logo--header"><Logo size="large" href="/" /></div>
  </header>
</template>

<script>
import { Logo } from '@nauticus-blockchain/nauticus-ui'
export default { name: 'H1Header', components: { Logo } }
</script>

<style lang="scss" scoped>
header {
  margin: 55px auto 0 auto;
  text-align: center;

  &:after {
    display: inline-block;
    width: 100%;
    height: 2vh;
    content: '';
  }
}
</style>
